// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"22971207","453":"3eda0dd7","780":"361e9924"}[chunkId] + ".chunk.js";
};